let GetBylineText = (authorName, authorLink) =>{
    let authorNames = []
    if (authorName) {
        authorNames = authorName.split(',')
    }
    let authorLinks = []
    if (authorLink) {
        authorLinks = authorLink.split(',')
    }
    let authorHTML = ""
    for (let i = 0; i<authorNames.length; i++){
        // If we have a matching link, build it
        if (authorLinks[i]){
            authorHTML += `<a itemscope="" itemprop="author" itemtype="http://schema.org/Person" class="byline-link" href=${authorLinks[i].includes('http') ? `\"${authorLinks[i].trim()}\"` : `\"https://${authorLinks[i].trim()}\"`}>${authorNames[i].trim()}</a>`
        } else {
            // If we don't just print the name
            authorHTML += `<span itemscope="" itemprop="author" itemtype="http://schema.org/Person">${authorNames[i].trim()}</span>`
        }
        if (i < authorNames.length - 2){
            authorHTML += ", "
        } else if (i === authorNames.length - 2){
            authorHTML += " and "
        }
    }
    return authorHTML
  }
  export { GetBylineText }